import { useState, useContext, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/auth';
import { CampaignContext } from '../../context/campaign';

import { fetchMyCampaign } from '~/services/campaign';

import { ProgressBar } from './ProgressBar';
import {
    Container,
    Button,
    Card,
    CardBody,
    Col,
    Row,
    FormGroup,
    Input,
    Label,
} from 'reactstrap';

import { Loading } from '../../shared/components/Loading';
import { renderIcon } from '../../shared/components/icons';

export const Share = ({}: any) => {
    const [{ campaign }, campaignDispatch] = useContext(CampaignContext);
    console.log('campaign: ', campaign);
    const [{ user }, userDispatch] = useContext(AuthContext);

    const [loading, setLoading] = useState<boolean>(true);

    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        if (!campaign) {
            getMyCampaign();
        } else {
            setLoading(false);
        }
    }, [campaign]);

    const getMyCampaign = async () => {
        try {
            const resp: MyCampaignResponse = await fetchMyCampaign();
            if (resp.detail) {
                // Delete localStorage token
                localStorage.removeItem('token');
                campaignDispatch({
                    type: 'set_campaign',
                    payload: null,
                });
                history.push('/login');
                return;
            } else {
                console.log('campaign loaded, setting context');
                campaignDispatch({
                    type: 'set_campaign',
                    payload: resp,
                });
                const { person, role } = resp;
                userDispatch({
                    type: 'set_person',
                    person,
                    role,
                });
            }
        } catch (e) {
            console.log('getMyCampaign() e: ', e);
            // Show some error here
        }
    };

    if (loading) {
        return <Loading />;
    }

    const shareLink = (type: string, label: string) => {
        let icon = renderIcon(type);
        return (
            <Col>
                <Card>
                    <CardBody>
                        {icon}
                        {label}
                    </CardBody>
                </Card>
            </Col>
        );
    };

    return (
        <Container>
            <ProgressBar selectedStep='share' />
            <Row className='justify-content-center py-5'>
                <Col md='6'>
                    <div className='text-center'>
                        <h3>
                            Congratulations, you’ve published your campaign!
                            Share your campaign to get your first donations.
                        </h3>
                    </div>

                    <Card
                        className='box-shadow my-5'
                        style={{
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }}
                    >
                        <CardBody className='p-5'>
                            <Row className='justify-content-between'>
                                <Col md='6'>
                                    <p>
                                        Click any of the social media outlets
                                        below or email to share directly to
                                        those sites.
                                    </p>
                                    <Row>
                                        {shareLink('facebook', 'Facebook')}
                                        {shareLink('twitter', 'Twitter')}
                                        {shareLink('messenger', 'Messenger')}
                                        {shareLink('email', 'Email')}
                                    </Row>
                                    <Row>
                                        <FormGroup>
                                            <Label>Campaign URL</Label>
                                            <Row>
                                                <Col>
                                                    <Input
                                                        readOnly={true}
                                                        value={
                                                            `/` +
                                                            campaign
                                                                ?.campaignEditInfo
                                                                ?.campaign_slug
                                                        }
                                                        name='campaign_slug'
                                                    />
                                                </Col>
                                                <Col>
                                                    <Button>Copy</Button>
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                    </Row>
                                </Col>
                                <Col md='5'>
                                    <Card className='bg-lightblue'>
                                        <CardBody>
                                            Campaigns that get shared generate
                                            XX% more on average
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <div className='text-center'>
                        <Button
                            color='primary'
                            onClick={() => history.push('/dashboard')}
                        >
                            Go to Dashboard
                        </Button>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};
